const tabMenus = document.querySelectorAll('.tab__menu-item');
tabMenus.forEach((tabMenu) => {
  tabMenu.addEventListener('click', (e) => {
    // クリックされた要素のデータ属性を取得
    const tabTargetData = e.currentTarget.dataset.tab;
    // クリックされた要素の親要素と、その子要素を取得
    const tabList = e.currentTarget.closest('.tab--list');
    // .tab--list 以外（例: food カレンダーの .tab-container 内）はこのハンドラの対象外
    if (!tabList) return;
    const tabItems = tabList.querySelectorAll('.tab__menu-item');
    const parentTabList = tabList.parentNode;

    const parentTabPanelItems = parentTabList.nextElementSibling;

    const tabPanelItems = parentTabPanelItems.children;
    console.log(tabPanelItems);
    // クリックされたtabの同階層のmenuとpanelのクラスを削除
    tabItems.forEach((tabItem) => {
      tabItem.classList.remove('is-active');
    });
    [...tabPanelItems].forEach((tabPanelItem) => {
      tabPanelItem.classList.remove('is-show');
    });

    // クリックされたmenu要素にis-activeクラスを付加
    e.currentTarget.classList.add('is-active');
    // クリックしたmenuのデータ属性と等しい値を持つパネルにis-showクラスを付加
    [...tabPanelItems].forEach((tabPanelItem) => {
      if (tabPanelItem.dataset.panel === tabTargetData) {
        tabPanelItem.classList.add('is-show');
      }
    });
  });
});
